export default __webpack_public_path__ + "img/7a194a21fcc503898f8a5bdbae08f203.svg";